import { BooleanField, Datagrid, DateField, List, SelectInput, TextField, TextInput, useListController } from 'react-admin';
import { LABELS } from 'shared/constants/labels';
import { TherapistListActions } from './ui/actions';
import { useEffect } from 'react';

const TagChoices = [
  { id: 'isB2B', name: 'B2B' },
  { id: 'isChildTherapist', name: 'Детский' },
  { id: 'isTop', name: 'Топ' },
  { id: 'isAdult', name: 'Взрослый' },
  { id: 'isTest', name: 'Тестовый' },
  { id: 'isSupervisor', name: 'Супервизор' },
  { id: 'isCoach', name: 'Коуч' },
];

const SearchTermChoices = [
  { id: 'email', name: 'Email' },
];

const therapistFilters = [
  <SelectInput label="Тэг" source="booleanFilter" choices={TagChoices} emptyText="Все" alwaysOn  />,
  <TextInput 
    label="Строка для поиска" 
    placeholder='Строка для поиска' 
    source="searchValue" 
    parse={value => value?.replace(/[^а-яА-Яa-zA-Z\d.,@+\s]/g, '').trim()}
    validate={value => {
      if (value && !/^[а-яА-Яa-zA-Z][а-яА-Яa-zA-Z\s\d.,@+]*$/.test(value)) {
        return 'Строка должна начинаться с буквы, затем можно использовать буквы, пробелы, цифры и символы .,@+';
      }
      return undefined;
    }}
    alwaysOn 
  />,
  <SelectInput label="Искать по:" source="searchTerm" choices={SearchTermChoices} emptyText="Имя" emptyValue="name" alwaysOn />,
];

export const TherapistList = () => {
  const { setFilters } = useListController();

  useEffect(() => {
    setFilters(
      { 
        searchTerm: 'name',
        searchValue: '',
        booleanFilter: ''
      },
      {}
    );
  }, []);

  return (
    <List actions={<TherapistListActions />} filters={therapistFilters} filterDefaultValues={{ searchTerm: 'name' }}>
      <Datagrid bulkActionButtons={false} rowClick="show">
        <TextField
          source="personalInfo.firstname"
          label={LABELS.firstname}
          sortable={false}
        />
        <TextField
          source="personalInfo.lastname"
          label={LABELS.lastname}
          sortable={false}
        />
        <TextField
          source="rewardInPercent"
          label={LABELS.rewardInPercent}
          sortable={false}
        />
        <BooleanField
          source="isTop"
          label={LABELS.isTop}
        />
        <BooleanField
          source="isTest"
          label={LABELS.isTestTherapist}
        />
        <BooleanField
          source="isMedsi"
          label={LABELS.isMedsi}
        />
        <BooleanField
          source="isAdult"
          label={LABELS.isAdult}
        />
        <BooleanField
          source="isChildTherapist"
          label={LABELS.isChildTherapist}
        />
        <BooleanField
          source="isSupervisor"
          label={LABELS.isSupervisorShort}
        />
        <BooleanField
          source="isB2B"
          label={LABELS.isB2B}
        />
        <BooleanField
          source="isCoach"
          label={LABELS.isCoach}
        />
        <DateField
          source="createdAt"
          label="Зарегистрирован"
          sortable={false}
          showTime
        />
      </Datagrid>
    </List>
  );
};
